import { useState } from "react";

const CRM_API = "https://feitevmd2k.execute-api.ap-south-1.amazonaws.com/prod/public/leads";
<script>
  const CRM_URL = "https://feitevmd2k.execute-api.ap-south-1.amazonaws.com/prod/public/leads";
</script>

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  border: "1.5px solid #d1d5db",
  borderRadius: "8px",
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "Segoe UI, sans-serif",
  transition: "border-color 0.2s",
};

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: "600",
  color: "#374151",
  marginBottom: "5px",
};

export default function BookingLeadModal({ packageInfo, onClose }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    travelDate: "",
    guests: "",
    message: packageInfo || "",
  });
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const f = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  async function submit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) return;
    setStatus("loading");
    try {
      const notes = [
        packageInfo && `Package: ${packageInfo}`,
        form.travelDate && `Travel Date: ${form.travelDate}`,
        form.guests && `Guests: ${form.guests}`,
        form.message && form.message !== packageInfo && `Message: ${form.message}`,
      ]
        .filter(Boolean)
        .join(" | ");

      const res = await fetch(CRM_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.trim(),
          phone: form.phone.trim(),
          email: form.email.trim() || null,
          source: "website",
          status: "new",
          notes: notes || null,
        }),
      });
      if (!res.ok) throw new Error("Server error");
      setStatus("success");
    } catch {
      setStatus("error");
      setErrorMsg("Something went wrong. Please try WhatsApp or call us directly.");
    }
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          width: "100%",
          maxWidth: "460px",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          animation: "slideUp 0.25s ease",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #00695c, #00897b)",
            padding: "20px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h2 style={{ margin: 0, color: "#fff", fontSize: "18px" }}>
              🌿 Book with OotyGo
            </h2>
            {packageInfo && (
              <p style={{ margin: "4px 0 0", color: "#b2dfdb", fontSize: "13px" }}>
                {packageInfo}
              </p>
            )}
          </div>
          <button
            onClick={onClose}
            style={{
              background: "rgba(255,255,255,0.2)",
              border: "none",
              color: "#fff",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              cursor: "pointer",
              fontSize: "18px",
              lineHeight: "32px",
              textAlign: "center",
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: "24px" }}>
          {status === "success" ? (
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <div style={{ fontSize: "52px", marginBottom: "12px" }}>🎉</div>
              <h3 style={{ color: "#00695c", margin: "0 0 8px" }}>
                We've Got Your Request!
              </h3>
              <p style={{ color: "#6b7280", fontSize: "14px", lineHeight: "1.6" }}>
                Thank you! Our team will contact you on WhatsApp or phone within a
                few hours to confirm your booking.
              </p>
              <button
                onClick={onClose}
                style={{
                  marginTop: "20px",
                  background: "#00695c",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 28px",
                  fontSize: "14px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                Close
              </button>
            </div>
          ) : (
            <form onSubmit={submit}>
              <div style={{ display: "grid", gap: "14px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                  <div>
                    <label style={labelStyle}>Name *</label>
                    <input
                      style={inputStyle}
                      placeholder="Your name"
                      value={form.name}
                      onChange={f("name")}
                      required
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>Phone *</label>
                    <input
                      style={inputStyle}
                      placeholder="Mobile number"
                      type="tel"
                      value={form.phone}
                      onChange={f("phone")}
                      required
                    />
                  </div>
                </div>

                <div>
                  <label style={labelStyle}>Email</label>
                  <input
                    style={inputStyle}
                    placeholder="your@email.com (optional)"
                    type="email"
                    value={form.email}
                    onChange={f("email")}
                  />
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                  <div>
                    <label style={labelStyle}>Travel Date</label>
                    <input
                      style={inputStyle}
                      type="date"
                      value={form.travelDate}
                      onChange={f("travelDate")}
                      min={new Date().toISOString().slice(0, 10)}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>No. of Guests</label>
                    <input
                      style={inputStyle}
                      placeholder="e.g. 4"
                      type="number"
                      min="1"
                      value={form.guests}
                      onChange={f("guests")}
                    />
                  </div>
                </div>

                <div>
                  <label style={labelStyle}>Message / Special Requests</label>
                  <textarea
                    style={{ ...inputStyle, resize: "vertical", minHeight: "72px" }}
                    placeholder="Anything specific you'd like us to know?"
                    value={form.message}
                    onChange={f("message")}
                  />
                </div>

                {status === "error" && (
                  <p style={{ color: "#dc2626", fontSize: "13px", margin: 0 }}>
                    {errorMsg}
                  </p>
                )}

                <button
                  type="submit"
                  disabled={status === "loading" || !form.name || !form.phone}
                  style={{
                    background:
                      status === "loading" || !form.name || !form.phone
                        ? "#9ca3af"
                        : "linear-gradient(135deg, #00695c, #00897b)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "13px",
                    fontSize: "15px",
                    fontWeight: "700",
                    cursor: status === "loading" ? "not-allowed" : "pointer",
                    width: "100%",
                    letterSpacing: "0.3px",
                  }}
                >
                  {status === "loading" ? "Sending…" : "🌿 Send Booking Request"}
                </button>

                <p style={{ textAlign: "center", color: "#9ca3af", fontSize: "12px", margin: 0 }}>
                  Or chat with us directly on{" "}
                  <a
                    href="https://wa.me/919655062118"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#25d366", fontWeight: "600" }}
                  >
                    WhatsApp
                  </a>
                </p>
              </div>
            </form>
          )}
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from { transform: translateY(30px); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
      `}</style>
    </div>
  );
}
